import { configureStore } from "@reduxjs/toolkit";
import patientReducer from "./slices/patientSlice";
import doctorReducer from "./slices/doctorSlice";
import appointmentReducer from "./slices/appointmentSlice";
import medicalRecordReducer from "./slices/medicalRecordSlice";
import subscriptionPlanReducer from "./slices/subscriptionPlanSlice";
import authReducer from "./slices/authSlice";
import adminReducer from "./slices/adminSlice";
import paymentReducer from "./slices/paymentSlice";
import roomReducer from "./slices/roomSlice";
import uiReducer from "./slices/uiSlice";

const store = configureStore({
  reducer: {
    patients: patientReducer,
    doctors: doctorReducer,
    appointments: appointmentReducer,
    medicalRecords: medicalRecordReducer,
    subscriptionPlans: subscriptionPlanReducer,
    auth: authReducer,
    admin: adminReducer,
    payments: paymentReducer,
    rooms: roomReducer,
    ui: uiReducer,
  },
});

export default store;
